import { combineReducers } from 'redux'
//import { routerReducer } from 'react-router-redux'
import page from './page'
import screen from './screen'
import auth from './auth'
import admin from './admin'
import customReducers from '../../reducers'

export default combineReducers({
	screen,
	page,
	auth,
	admin,
	...customReducers
})



// WEBPACK FOOTER //
// ./src/fm/reducers/index.js